import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/consumer/Placeholder';
import ProtectionPlanButtonAndModal from 'components/consumer/ProtectionPlanButtonAndModal';
import usePdpSelectedProtectionPlanId from '../state/pdpSelectedProtectionPlanId/usePdpSelectedProtectionPlanId';
import useResetPdpSelectedProtectionPlanId from '../state/pdpSelectedProtectionPlanId/useResetPdpSelectedProtectionPlanId';
const PDPProtectionPlanSelectorUI = t0 => {
  const $ = _c(16);
  const {
    allProtectionPlanTypes,
    loading,
    meta,
    onProtectionPlanSelection
  } = t0;
  const [isProtectionModalOpen, setIsProtectionModalOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsProtectionModalOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const openProtectionModal = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsProtectionModalOpen(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const closeProtectionModal = t2;
  const pdpSelectedProtectionPlanId = usePdpSelectedProtectionPlanId();
  const resetPdpSelectedProtectionPlanId = useResetPdpSelectedProtectionPlanId();
  if (loading) {
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="min-h-[66px] mt-8 mx-0 mb-0 w-full"><Placeholder type="rect" loading={true} style={{
          height: "52px"
        }} /></div>;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    return t3;
  }
  let t3;
  if ($[3] !== allProtectionPlanTypes || $[4] !== pdpSelectedProtectionPlanId) {
    t3 = pdpSelectedProtectionPlanId ? allProtectionPlanTypes.filter(singlePlan => singlePlan.plan_id === pdpSelectedProtectionPlanId)?.[0] : null;
    $[3] = allProtectionPlanTypes;
    $[4] = pdpSelectedProtectionPlanId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const selectedProtectionPlan = t3;
  let t4;
  if ($[6] !== allProtectionPlanTypes || $[7] !== meta?.eligible_protection_planids) {
    t4 = allProtectionPlanTypes ? allProtectionPlanTypes.filter(singlePlan_0 => meta?.eligible_protection_planids.includes(singlePlan_0.plan_id)) : [];
    $[6] = allProtectionPlanTypes;
    $[7] = meta?.eligible_protection_planids;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const eligible_plans = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h3 className="text-base font-bold mt-0 mx-0 mb-1.5">Protect Your Investment</h3>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== eligible_plans || $[11] !== isProtectionModalOpen || $[12] !== onProtectionPlanSelection || $[13] !== resetPdpSelectedProtectionPlanId || $[14] !== selectedProtectionPlan) {
    t6 = <div className="min-h-[66px] mt-8 mx-0 mb-0 w-full">{t5}<ProtectionPlanButtonAndModal close={closeProtectionModal} eligible_plans={eligible_plans} forPage="PDP" isOpen={isProtectionModalOpen} onSelect={onProtectionPlanSelection} openModal={openProtectionModal} removeProtectionPlan={resetPdpSelectedProtectionPlanId} selectedProtectionPlan={selectedProtectionPlan} /></div>;
    $[10] = eligible_plans;
    $[11] = isProtectionModalOpen;
    $[12] = onProtectionPlanSelection;
    $[13] = resetPdpSelectedProtectionPlanId;
    $[14] = selectedProtectionPlan;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
PDPProtectionPlanSelectorUI.propTypes = {
  allProtectionPlanTypes: PropTypes.array,
  loading: PropTypes.bool,
  meta: PropTypes.object,
  onProtectionPlanSelection: PropTypes.func
};
export default PDPProtectionPlanSelectorUI;